import React from 'react';
import classNames from 'classnames';
import { ButtonProps } from './Button';

type Props = ButtonProps & {
  noBorder?: boolean;
};

const SecondaryLink = ({ children, className, icon, disabled, dark, noBorder, ...rest }: Props) => (
  <button type="button" className={classNames('secondary-link', className, { disabled, dark, 'no-border': noBorder })} {...rest}>
    {icon && <i className={`icon-${icon}`} />}
    {children}
  </button>
);

export default SecondaryLink;
